var map = {
	"./angular.png": 3301,
	"./bootstrap.png": 8926,
	"./css.png": 1303,
	"./django.png": 5681,
	"./express-js.png": 6206,
	"./html.png": 5963,
	"./image-home.png": 878,
	"./java.png": 1783,
	"./javascript.png": 115,
	"./logo.png": 1053,
	"./mysql.png": 8279,
	"./php.png": 1854,
	"./posgresql.png": 8358,
	"./projects/portfolio.png": 9726,
	"./python.png": 7600,
	"./react.png": 5075,
	"./spring.png": 6370,
	"./sql.png": 9888,
	"./sqlite.png": 2321,
	"./typescript.png": 1264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;